import type { Theme } from '@mui/material';

export const styles = {
  responseManager: {
    display: 'flex',
    width: '100%',
    overflow: 'auto',
    justifyContent: 'space-between',
    whiteSpace: 'nowrap',

    '.diff-column__header': {
      width: '5.25rem',
    },
  },

  firstColumn: (theme: Theme) => ({
    background: theme.colors.white,
    left: 0,
    position: 'sticky',
    zIndex: 1,
  }),
};
